module.exports = __webpack_public_path__ + "img/komuni-pertama.48ba8c74.jpg";